module.exports = __webpack_public_path__ + "static/media/67d9872c-cef5-4d68-a686-5b102351541f.761b916b.jpeg";